import React from "react";
import ReactDOM from "react-dom/client";
import SmartCartAI from "./SmartCartAI";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SmartCartAI />
  </React.StrictMode>
);